import React from "react";

/**
 * Function to render a time picker clock SVG component.
 *
 * @param {Object} cls - class name for styling
 * @return {JSX.Element} - SVG component
 */
export const TimePickerClock = ({ cls }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M10 2.25C5.58891 2.25 2 5.83872 2 10.25C2 14.6613 5.58891 18.25 10 18.25C14.4113 18.25 18 14.6613 18 10.25C18 5.83872 14.4111 2.25 10 2.25ZM10 17.0821C6.23281 17.0821 3.16788 14.0172 3.16788 10.25C3.16788 6.48281 6.23281 3.41788 10 3.41788C13.7672 3.41788 16.8321 6.48278 16.8321 10.2498C16.8321 14.0172 13.7672 17.0821 10 17.0821Z"
        fill="currentColor"
      />
      <path
        d="M12.4545 10.1389H10.0909V6.80555C10.0909 6.4987 9.84673 6.25 9.54545 6.25C9.24418 6.25 9 6.4987 9 6.80555V10.6944C9 11.0013 9.24418 11.25 9.54545 11.25H12.4545C12.7558 11.25 13 11.0013 13 10.6944C13 10.3876 12.7558 10.1389 12.4545 10.1389Z"
        fill="currentColor"
      />
    </svg>
  );
};
